<template>
  <section class="relative overflow-hidden">
    <div class="pointer-events-none absolute inset-0">
      <div class="absolute left-10 top-20 h-64 w-64 rounded-full bg-neon-400/10 blur-3xl"></div>
      <div class="absolute right-0 top-1/4 h-80 w-80 rounded-full bg-white/5 blur-3xl"></div>
    </div>
    <div class="relative mx-auto flex min-h-[70vh] max-w-6xl flex-col justify-center gap-8 px-6 py-16 text-center sm:text-left">
      <p class="text-xs uppercase tracking-[0.35em] text-steel-400">DRVN / Lifestyle Collective</p>
      <h1 class="max-w-3xl font-display text-4xl font-semibold tracking-tight text-white sm:text-5xl">
        Curated drives, member-only drops, and the people who build the culture.
      </h1>
      <p class="mx-auto max-w-2xl text-base text-steel-200/90 sm:text-lg sm:mx-0">
        DRVN celebrates the art of motion with modern design, premium storytelling, and a community built for the long way home.
      </p>
      <div class="flex flex-wrap justify-center gap-4 sm:justify-start">
        <router-link
          class="rounded-2xl bg-white px-6 py-3 text-sm font-semibold uppercase tracking-[0.3em] text-midnight-900 transition hover:bg-neon-400"
          to="/register"
        >
          Become a member
        </router-link>
        <router-link
          class="rounded-2xl border border-white/15 bg-white/5 px-6 py-3 text-sm font-semibold uppercase tracking-[0.3em] text-white transition hover:border-white/30 hover:bg-white/10"
          to="/login"
        >
          Member login
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomeView',
}
</script>
